import { CountryModel } from "@insite/client-framework/Types/ApiModels";
import { AddressModel } from "@store/Services/CheckoutService";

export const autocompleteAddressMapping = (countries: CountryModel[], address: AddressModel) => {
    const countryLookup = countries.find(c => c.abbreviation === address?.countryCode);
    const newAddress: any = {};

    Object.keys(address).forEach(key => {
        if (key === "id") {
            return;
        }
        const value:any = (address as any)[key];
        if (value && value !== "") {
            if (key === "countryCode" && countryLookup) {
                newAddress["country"] = countryLookup;
                return;
            } if (key === "stateCode" && countryLookup) {
                const stateLookup = countryLookup?.states?.find(s => s.abbreviation === address?.stateCode);
                newAddress["state"] = stateLookup;
                return;
            }
            newAddress[key] = value;
        }
    });

    return newAddress;
}